import React, { useEffect, useState } from 'react';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import shopOwnerImage from '../../components/common/Images/User.webp';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import CommonButton from '../../components/common/button/Button';
import ChangePasswordDialogBox from './ChangePasswordDialog';
import './Profile.css';

interface Shop {
    fullName: string,
    address: string,
    logo: string,
    subscriptionPlan: string,
    paymentStatus: string,
    isSubscribed: boolean,
    email: string,
    phone: string,
    isActive: boolean,
    createdAt: string,
    storename: string,
    ticketslocation: string,
    subscriptionId: string
};

const shopIntialData = {
    fullName: "",
    address: "",
    logo: "",
    subscriptionPlan: "",
    paymentStatus: "",
    isSubscribed: false,
    email: "",
    phone: "",
    isActive: false,
    createdAt: "",
    storename: "",
    ticketslocation: "",
    subscriptionId: ""
}

const subscriptionNames = ["Basic", "Basic Plus", "Popular", "Premium"];

const Profile: React.FC = () => {

    //@ts-ignore
    const config = window.config;
    const { t } = useTranslation("translation");
    const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
    const [shopDetails, setShopDetails] = useState<Shop>(shopIntialData);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        getParticularTicketDetails();
    }, []);

    const getParticularTicketDetails = () => {
        let localData = localStorage.getItem('UserData');
        const shopownerData = localData ? JSON.parse(localStorage.getItem('UserData') || "") : null;
        axios.get(`${apiBaseURL}/api/shop/fetchParticularShopDetail?id=${shopownerData?.uId}`).then((data: any) => {
            if (data?.status == 200) {
                let shopDetail = data?.data?.shopDetails;
                let subscriptionDetail = data?.data?.subscriptionDetails;
                setShopDetails({
                    fullName: shopDetail?.fullName,
                    address: shopDetail?.address,
                    logo: shopDetail?.logo,
                    subscriptionPlan: subscriptionDetail?.nextSubscriptionDate,
                    paymentStatus: subscriptionDetail?.paymentStatus,
                    isSubscribed: subscriptionDetail?.isSubscribed,
                    email: shopDetail?.email,
                    phone: shopDetail?.phone,
                    isActive: shopDetail?.isActive,
                    createdAt: subscriptionDetail?.createdAt?.split("T")[0],
                    storename: shopDetail?.storename,
                    ticketslocation: shopDetail?.ticketslocation,
                    subscriptionId: subscriptionDetail?.subscriptionId
                });
            }
        }).catch((err: any) => {
            console.log("err", err)
        }).finally(() => {
        })
    }

    return (
        <div className='profile-page'>
            <div className='profile-page__account'>
                <div className='profile-page__card'>
                    <div className='profile-page__card-title'>Account Details</div>
                    <div className='profile-page__avatar-wrap'>
                        <img
                            alt="shopowner-image"
                            src={shopDetails?.logo ? shopDetails?.logo : shopOwnerImage}
                        />
                    </div>
                    <div className='profile-page__list'>
                        <div className='profile-page__list-item'>
                            <div className='profile-page__list-item-icon'>
                                <AccessTimeFilledIcon />
                            </div>
                            <div className='profile-page__list-item-content'>
                                <div className='profile-page__list-item-label'>Member Since</div>
                                <div className='profile-page__list-item-value'>{shopDetails?.createdAt ? shopDetails?.createdAt : "-"}</div>
                            </div>
                        </div>
                        <div className='profile-page__list-item'>
                            <div className='profile-page__list-item-icon'>
                                <HowToRegIcon />
                            </div>
                            <div className='profile-page__list-item-content'>
                                <div className='profile-page__list-item-label'>Subscribed</div>
                                <div className='profile-page__list-item-value'>{shopDetails?.isSubscribed ? 'Yes' : 'No'}</div>
                            </div>
                        </div>
                        <div className='profile-page__list-item'>
                            <div className='profile-page__list-item-icon'>
                                <HowToRegIcon />
                            </div>
                            <div className='profile-page__list-item-content'>
                                <div className='profile-page__list-item-label'>Current Subscription</div>
                                <div className='profile-page__list-item-value'>{subscriptionNames[parseInt(shopDetails?.subscriptionId) - 1]}</div>
                                <div className='profile-page__list-item-value' style={{ fontWeight: 600 }}>Contact admin to change subscription plan</div>
                            </div>
                        </div>
                        <div className='profile-page__list-item'>
                            <div className='profile-page__list-item-icon'>
                                <PendingActionsIcon />
                            </div>
                            <div className='profile-page__list-item-content'>
                                <div className='profile-page__list-item-label'>Next Subscription Date</div>
                                <div className='profile-page__list-item-value'>{shopDetails?.subscriptionPlan ? shopDetails?.subscriptionPlan : "-"}</div>
                            </div>
                        </div>
                        <div className='profile-page__list-item'>
                            <div className='profile-page__list-item-icon'>
                                <PendingActionsIcon />
                            </div>
                            <div className='profile-page__list-item-content'>
                                <div className='profile-page__list-item-label'>Payment Status</div>
                                <div className='profile-page__list-item-value'>{shopDetails?.paymentStatus ? shopDetails?.paymentStatus : "-"}</div>
                            </div>
                        </div>
                        <div className='profile-page__list-item'>
                            <div className='profile-page__list-item-icon'>
                                <ManageAccountsIcon />
                            </div>
                            <div className='profile-page__list-item-content'>
                                <div className='profile-page__list-item-label'>Account Active</div>
                                <div className='profile-page__list-item-value'>{shopDetails?.isActive ? 'Yes' : 'No'}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='profile-page__details'>
                <div className='profile-page__card'>
                    <div className='profile-page__card-title profile-page__card-title--left'>Profile Details</div>
                    <div className='profile-page__details-rows'>
                        <div className='profile-page__details-row'>
                            <span className='profile-page__details-label'>{t("fullname")}</span>
                            <span className='profile-page__details-value'>{shopDetails?.fullName || "-"}</span>
                        </div>
                        <div className='profile-page__details-row'>
                            <span className='profile-page__details-label'>{t("storeName")}</span>
                            <span className='profile-page__details-value'>{shopDetails?.storename || "-"}</span>
                        </div>
                        <div className='profile-page__details-row'>
                            <span className='profile-page__details-label'>{t("address")}</span>
                            <span className='profile-page__details-value'>{shopDetails?.address || "-"}</span>
                        </div>
                        <div className='profile-page__details-row'>
                            <span className='profile-page__details-label'>{t("phone")}</span>
                            <span className='profile-page__details-value'>{shopDetails?.phone || "-"}</span>
                        </div>
                        <div className='profile-page__details-row'>
                            <span className='profile-page__details-label'>{t("email")}</span>
                            <span className='profile-page__details-value'>{shopDetails?.email || "-"}</span>
                        </div>
                    </div>
                    <div className='profile-page__change-password-wrap'>
                        <CommonButton
                            id='change-password--button'
                            variant='contained'
                            size='small'
                            onClick={(e) => setOpen(true)}
                        >
                            {t("changePassword")}
                        </CommonButton>
                    </div>
                </div>
            </div>
            <ChangePasswordDialogBox open={open} setOpen={setOpen}/>
        </div>
    )
}

export default Profile;